import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from "vue-resource"
import settings from "./backend/LocalSettings";


var currencyFormatter = require('currency-formatter');

Vue.config.productionTip = false

Vue.use(VueResource);


Vue.http.options.emulateJSON = true;
Vue.http.options.root = settings.BASE_URL;


Vue.filter( 'money_format', function(value){
  return currencyFormatter.format(value, {
      symbol: '',
      decimal: ',',
      thousand: '.',
      precision: 2,
      format: '%v'
    });
} );

function isJSON(str) {
  try {
      return (JSON.parse(str) && !!str);
  } catch (e) {
      return false;
  }
}

Vue.filter( 'translate_in_default_language', function(value){
  if( isJSON(value)){
    var _values   = JSON.parse(value);
    var lang      = settings.get_default_language();

    var ret    = "";
    if( value == "" ) return ret;

    var filtered = _values.filter( x => x.Lang == lang );
    if( filtered.length > 0 ){
        ret = filtered[0].Valoare;
    }
    return ret;
  } else {
    return value;
  }
} );

Vue.filter( 'translate_in_ro', function(value){
  if( isJSON(value)){
    var _values   = JSON.parse(value);
    var lang      = "RO";

    var ret    = "";
    if( value == "" ) return ret;

    var filtered = _values.filter( x => x.Lang == lang );
    if( filtered.length > 0 ){
        ret = filtered[0].Valoare;
    }
    return ret;
  } else {
    return value;
  }
} );

Vue.filter( 'translate_in_language', function(value, lang){
  if( isJSON(value)){
    var _values   = JSON.parse(value);

    var ret    = "";
    if( value == "" ) return ret;

    var filtered = _values.filter( x => x.Lang == lang );
    if( filtered.length > 0 ){
        ret = filtered[0].Valoare;
    }
    if( ret == "" ) {
      //fallback in romana
      var filtered = _values.filter( x => x.Lang == "RO" );
      if( filtered.length > 0 ){
          ret = filtered[0].Valoare;
      }
    }
    return ret;
  } else {
    return value;
  }
} );

var app = new Vue({
  router,
  store,
  render: h => h(App)
});



app.$mount('#app');
